// Line icons for the Dock / profile menu — stroke uses currentColor so
// callers control color via CSS (base #e8f0ea, green #2ed573 on hover/active).
const common = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const IconProfile = (props) => (
  <svg {...common} {...props}>
    <circle cx="12" cy="8" r="4"/>
    <path d="M4.5 20c0-4 3.4-6 7.5-6s7.5 2 7.5 6"/>
  </svg>
);

export const IconFamily = (props) => (
  <svg {...common} {...props}>
    <circle cx="9" cy="8" r="3.2"/>
    <path d="M3.5 19c0-3.3 2.5-5 5.5-5s5.5 1.7 5.5 5"/>
    <circle cx="17.2" cy="9.4" r="2.4"/>
    <path d="M15.6 14.2c3 .2 4.9 1.9 4.9 4.8"/>
  </svg>
);

export const IconSupport = (props) => (
  <svg {...common} {...props}>
    <path d="M5 13a7 7 0 0 1 14 0"/>
    <rect x="3.2" y="12.5" width="3.2" height="6.3" rx="1.5"/>
    <rect x="17.6" y="12.5" width="3.2" height="6.3" rx="1.5"/>
    <path d="M19.2 18.8c0 1.6-1.3 2.7-3.2 2.7H13"/>
  </svg>
);

export const IconPlans = (props) => (
  <svg {...common} {...props}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.6"/>
    <path d="M2.5 9.5h19"/>
    <path d="M6 15h4"/>
  </svg>
);

export const IconSignOut = (props) => (
  <svg {...common} {...props}>
    <path d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4"/>
    <path d="M15 8l4 4-4 4"/>
    <path d="M19 12H9"/>
  </svg>
);

export const IconSearch = (props) => (
  <svg {...common} {...props}>
    <circle cx="10.5" cy="10.5" r="6.5"/>
    <path d="M20 20l-4.8-4.8"/>
  </svg>
);

export const IconFile = (props) => (
  <svg {...common} {...props}>
    <path d="M7 3.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V5A1.5 1.5 0 0 1 7 3.5z"/>
    <path d="M14 3.5V8h4"/>
  </svg>
);

export const IconUpload = (props) => (
  <svg {...common} {...props}>
    <path d="M12 16V5"/>
    <path d="M7 10l5-5 5 5"/>
    <path d="M4 19h16"/>
  </svg>
);
